import {Placeholder} from 'react-bootstrap';

function PageLoadHandler() {
    let style={
        borderRadius:'12px'
    }
  return (
    <div style={{display: 'block',marginLeft: 'auto',marginRight: 'auto',width: '80%',paddingTop:'60px'}}>
      <Placeholder as="p" animation="glow">
        <Placeholder xs={12} style={style}/>
        <Placeholder xs={12} style={style}/>
        <Placeholder xs={12} style={style}/>
        <Placeholder xs={12} style={style}/>
        <Placeholder xs={12} style={style}/>
        <Placeholder xs={12} style={style}/>
        <Placeholder xs={12} style={style}/>
        <Placeholder xs={12} style={style}/>
        <Placeholder xs={12} style={style}/>
        <Placeholder xs={12} style={style}/>
      </Placeholder>
      <Placeholder as="p" animation="glow">
        <Placeholder xs={12} style={style}/>
        <Placeholder xs={12} style={style}/>
        <Placeholder xs={12} style={style}/>
        <Placeholder xs={12} style={style}/>
        <Placeholder xs={12} style={style}/>
        <Placeholder xs={12} style={style}/>
        <Placeholder xs={12} style={style}/>
        <Placeholder xs={12} style={style}/>
        <Placeholder xs={12} style={style}/>
        <Placeholder xs={12} style={style}/>
      </Placeholder>
    </div>
  );
}

export default PageLoadHandler;